import {
  PravoEuDetailResponse,
  PravoEuDetailApi, PdfPriloha,
} from 'pravo-eu-frontend-ts-axios';
import { ClientResponse } from '../model/ClientResponse';
import PravoEuDetail from '../model/PravoEuDetail';
import { pravoEuPrefixPath } from './configuration/apiConfigurationConstants';
import PravnyZaklad from '../model/PravnyZaklad';
import ApiConfiguration from './configuration/apiConfiguration';
import PredpisEurlexPriloha from '../model/PredpisEurlexPriloha';

const client = new PravoEuDetailApi(ApiConfiguration(pravoEuPrefixPath));

const mapPravnyZaklad = (pravnyZaklad: string): PravnyZaklad => ({
  url: pravnyZaklad,
  nazov: pravnyZaklad,
});

const mapPriloha = (data: PdfPriloha): PredpisEurlexPriloha => (data ? {
  uuid: data.uuid,
  fileSize: data.size,
  fileName: data.fileName,
} : undefined);

const map = (data: PravoEuDetailResponse): PravoEuDetail => ({
  ...data.predpisEurlex,
  datumSchvalenia: data.predpisEurlex.datumSchvalenia ? new Date(data.predpisEurlex.datumSchvalenia) : undefined,
  datumUcinnostiOd: data.predpisEurlex.datumUcinnostiOd ? new Date(data.predpisEurlex.datumUcinnostiOd) : undefined,
  datumUcinnostiDo: data.predpisEurlex.datumUcinnostiDo ? new Date(data.predpisEurlex.datumUcinnostiDo) : undefined,
  datumUverejnenia: data.predpisEurlex.datumUverejnenia ? new Date(data.predpisEurlex.datumUverejnenia) : undefined,
  datumUzavierky: data.predpisEurlex.datumUzavierky ? new Date(data.predpisEurlex.datumUzavierky) : undefined,
  datumTranspozicie: data.predpisEurlex.datumTranspozicie ? new Date(data.predpisEurlex.datumTranspozicie) : undefined,
  zoznamPravnychZakladov: data.predpisEurlex.zoznamPravnychZakladov?.map(pravnyZaklad => mapPravnyZaklad(pravnyZaklad)),
  prilohaPravoEuList: data.pdfPrilohaList.map(priloha => mapPriloha(priloha)),
  htmlFileContent: data.htmlContent,
});

// eslint-disable-next-line import/prefer-default-export
export const fetchPravoEuDetail = async (
  uuid: string,
):
  Promise<ClientResponse<PravoEuDetail>> => {
  const {
    data,
    status,
  } = await client.getPravoEuDetail(uuid);
  return {
    data: map(data),
    responseCode: status,
  };
};
